
import { Card } from "@/components/ui/card";
import { FunnelForm } from "./FunnelForm";
import { Preview } from "./Preview";
import type { FunnelData } from "./types";

interface DesktopBuilderProps {
  funnelData: FunnelData;
  selectedPageId: string | null;
  onUpdate: (data: FunnelData) => void;
  onPageSelect: (pageId: string) => void;
  handleImageUpload: (e: React.ChangeEvent<HTMLInputElement>, type: 'logo' | 'headerImage') => void;
}

export const DesktopBuilder = ({
  funnelData,
  selectedPageId,
  onUpdate,
  onPageSelect,
  handleImageUpload
}: DesktopBuilderProps) => {
  return (
    <div className="flex-1 grid lg:grid-cols-2 gap-4 px-4 pb-4">
      <Card className="h-[calc(100vh-8rem)] order-2 lg:order-1 bg-white/50 backdrop-blur-sm border-slate-200/60 shadow-sm hover:shadow-md transition-all duration-300">
        <div className="h-full overflow-auto">
          <FunnelForm 
            onUpdate={onUpdate} 
            initialData={funnelData} 
            onPageSelect={onPageSelect}
            handleImageUpload={handleImageUpload}
          />
        </div>
      </Card>
      <Card className="h-[calc(100vh-8rem)] order-1 lg:order-2 bg-white/50 backdrop-blur-sm border-slate-200/60 shadow-sm hover:shadow-md transition-all duration-300">
        <Preview 
          data={funnelData} 
          currentPage={selectedPageId} 
          showAfterSubmit={false}
        />
      </Card>
    </div>
  );
};
